<button
  mat-icon-button
  matTooltip="Favourites"
  matTooltipPosition="above"
  style="margin-right: 8px"
  (click)="onToggle()"
  color="error"
>
  <mat-icon>{{ isFavourite ? "favorite" : "favorite_border" }}</mat-icon>
</button>
